module.exports = "<ui-view></ui-view>"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/differential/differential.html
// module id = 541
// module chunks = 0